import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/components/app/App';
import { initVersionMonitoring } from '@/utils/buildVersionMonitoring';
import { TopLevelProviders } from './TopLevelProviders';
import { Provider } from 'react-redux';
import { getStore } from './store';

initVersionMonitoring();
const store = getStore();

setInterval(() => {
    localStorage.setItem('cm-lastDate', JSON.stringify(new Date()));
}, 10000);

const domNode = document.getElementById('root')!;
const root = createRoot(domNode);

root.render(
    <Provider store={store}>
        <TopLevelProviders>
            <App />
        </TopLevelProviders>
    </Provider>
);
